/**
 * ThemeToggle Component
 *
 * Dark mode toggle button using unified Icon System.
 */

import React from 'react'
import { useTheme } from 'next-themes'

import { Icon } from './ui/icon'
import { cn } from '@/lib/utils'

interface ThemeToggleProps {
  readonly className?: string
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  // Avoid hydration mismatch
  React.useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  const isDark = resolvedTheme === 'dark'

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className={cn('p-2 rounded-lg border bg-background hover:bg-accent transition-colors', className)}
      aria-label="Toggle theme"
    >
      <Icon name={isDark ? 'status.sun' : 'status.moon'} size="md" />
    </button>
  )
}
